const maxPriceThreshold = 1000
const minPriceThreshold = 2
const maxPolygonThreshold = 1000000
const minPolygonThreshold = 0
const listingHeaderHeight = 50

export {
  maxPriceThreshold,
  minPriceThreshold,
  maxPolygonThreshold,
  minPolygonThreshold,
  listingHeaderHeight,
}
